import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import AddressContent from '../../../../fragments/address/address-content'
import TitleBox from '../../components/title-box'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../../../components/icon/iconfont'

export default props => {
    useStyles(classes)
    const { address, onEdit } = props
    return <TitleBox title={<FormattedMessage id="shipping_address"/>} extra={<Iconfont onClick={onEdit} className={classes.Editor}>&#xe778;</Iconfont>}>
        <div className={classes.Container}>
            <Iconfont className={classes.LocateIcon}>&#xe691;</Iconfont>
            <AddressContent address={address} />
        </div>
        
    </TitleBox>
}